export enum QBRRounding {
  AsIs = 'AsIs',
  K = 'K',
  M = 'M',
}
